import React from 'react'
import {
  exportedModelGif,
  exporteddateGif,
  exportedListGiff,
  exportedphotoGif,
  exportedsampleTextGif,
  exportedsampleImageGif,
  exportedsampleVideoGif,
  exportednumberGif,
  exportedtextGif,
  exportedyesOrNoGif,
  exportedgpsGif,
  exporteddrawGif,
  exportedScoreGif,
  exportedCalculatorGif,
  exportedToDoGif,
  exportedAudioGif,
  exportedSampleGif,
  exportedQRCodeGif
} from '@helpers/importHelpers/gifsImportHelper'

const gifReturner = (gif: any) => {
  switch (gif) {
    case 'Text':
      return <img src={exportedtextGif} />
    case 'Photo':
      return <img src={exportedphotoGif} />
    case 'Number':
      return <img src={exportednumberGif} />
    case 'Date':
      return <img src={exporteddateGif} />
    case 'GPS':
      return <img src={exportedgpsGif} />
    case 'Draw':
      return <img src={exporteddrawGif} />
    case 'Model':
      return <img src={exportedModelGif} />
    case 'SAMPLETEXT':
      return <img src={exportedsampleTextGif} />
    case 'SAMPLEIMAGE':
      return <img src={exportedsampleImageGif} />
    case 'SAMPLEVIDEO':
      return <img src={exportedsampleVideoGif} />
    case 'Select':
      return <img src={exportedListGiff} />
    case 'Score':
      return <img src={exportedScoreGif} />
    case 'Score':
      return <img src={exportedScoreGif} />
    case 'Calculator':
      return <img src={exportedCalculatorGif} />
    case 'TODO':
      return <img src={exportedToDoGif} />
    case 'Yes/No':
      return <img src={exportedyesOrNoGif} />
    case 'Audio':
      return <img src={exportedAudioGif} />
    case 'Sample':
      return <img src={exportedSampleGif} />
    case 'QRCode':
      return <img src={exportedQRCodeGif} />
    default:
      return <div />
  }
}

export default gifReturner


